import React from "react";
import loadingScreen from "../../assets/img/NokiaAnimation.gif";
import { Loader2 } from "lucide-react";

const LoadingMessage = () => {
  return (
    <div>
      <div className="card chatting-box mb-0">
        <div
          style={{
            display: "grid",
            gridGap: "1rem",
            padding: "1rem",
            justifyContent: "center",
            alignItems: "center",
            height: "90vh",
            alignContent: "center",
            justifyItems: "center",
            background:"#ffffff"
          }}
        >
          <span>
            <img style={{ width: "80px" }} src={loadingScreen} alt="logo" />
          </span>
          {/* <span>Getting your history </span> */}
          <div className="flex items-center gap-2 text-gray-600">
                                                        <Loader2 className="animate-spin w-5 h-5" />
                                                        <span>Getting your history</span>
                                                      </div>
        </div>
      </div>
    </div>
  );
};

export default LoadingMessage;
